export default "__VITE_ASSET__DuTJ9m3y__"